/* NovaWaveUSA: one-time subtle section entrances + JS flag.
   Content stays fully visible if this script fails to load. */
(function () {
  document.documentElement.classList.add('nw-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  var sections = document.querySelectorAll('main .shopify-section');
  // Skip the first section (hero) — it is above the fold.
  sections = Array.prototype.slice.call(sections, 1);

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nw-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  sections.forEach(function (section) {
    section.classList.add('nw-reveal');
    io.observe(section);
  });
})();

/* NovaWaveUSA: custom-design line-item properties.
   The #custom-design-fields block must live INSIDE the product form so
   "properties[Design instructions]" submits with add-to-cart. The block's
   own inline script can no-op (stale data-moved guard baked into content),
   so this is the authoritative placement: clear the stale guard, move the
   fields into the form before the buy buttons, watch for late renders. */
(function () {
  function placeFields() {
    var fields = document.getElementById('custom-design-fields');
    if (!fields) return false;
    fields.removeAttribute('data-moved');
    var form =
      document.querySelector('product-form-component form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return false;
    if (fields.parentElement === form) return true;
    var addBtn = form.querySelector('[name="add"], button[type="submit"]');
    var beforeNode = null;
    if (addBtn) {
      beforeNode = addBtn;
      while (beforeNode && beforeNode.parentElement !== form) {
        beforeNode = beforeNode.parentElement;
      }
    }
    if (beforeNode) form.insertBefore(fields, beforeNode);
    else form.appendChild(fields);
    return true;
  }
  function init() {
    if (placeFields()) return;
    var done = false;
    var obs = new MutationObserver(function () {
      if (!done && placeFields()) {
        done = true;
        obs.disconnect();
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
      placeFields();
    }, 6000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
